const Clone = function() {
	return JSON.parse(JSON.stringify.apply(this, arguments))
}

export { Clone }

const AttributeBoolean = key => {
	return function() {
		return ['', true, 'true'].includes(this.$attrs[key])
	}
}

export { AttributeBoolean }

import path from 'ramda/src/path'

const Path = (obj, key, def, renderDef = true) => {
	let val = path(key.split('.'), obj)
	if (val) return val
	if (renderDef) return def
}

export { Path }
